var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.request},[_c('icon',{class:_vm.$style.icon,attrs:{"name":"double-chevron","width":"12","height":"12"}}),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('icon',{class:_vm.$style.icon,attrs:{"name":"chevron","width":"6","height":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }